module.exports = __webpack_public_path__ + "static/media/SeasonBanner.4eabd31a.svg";